import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Video } from 'src/app/models/video.model';
import { UsersService } from 'src/app/services/users.service';
import { VideosService } from 'src/app/services/videos.service';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  searchText: string = ""

  @Input()
  showBlocked: boolean

  @Output()
  makeSearch = new EventEmitter<string>();

  focus: boolean = false

  offers: Video[] = []
  offersAll: Video[] = []
  userid: number = 0
  constructor(private router: Router, private route: ActivatedRoute, private videoService: VideosService, private usersService: UsersService) { }

  ngOnInit(): void {
    this.usersService.currentUser.subscribe(u => this.userid = u.userId)
    this.route.queryParams
      .subscribe(params => {
        this.searchText = params['text']
      },
        err => console.log(err))
  }

  IfEnterSearch(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      this.makeClick()
    }
  }

  getOffers() {
      if (this.searchText.length == 0)
        this.offers = []
      else
        if (this.searchText.length > 2)
          this.videoService.getOffers(this.searchText).subscribe(d => {
            this.offers = d
          })
      // else}
      // if (this.searchText.length > 4)
      // this.offers = this.offersAll.filter(o => o.title.startsWith(this.searchText))
      // else
      // this.offers=[]
      console.log(this.offers)
  }

    makeClick() {
      document.getElementById('search-icon')?.click();
    }

    search() {
      if (this.searchText !== "" && this.searchText) {
        this.makeSearch.emit(this.searchText)
      }
    }
  }
